// Vendors
import { Illustration, ParagraphComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { BACKGROUND_ILLUSTRATION_COMPONENT_PROPS } from './constants/background-content.constants';
// Styles
import { BackgroundContentComponentStyled } from './background-content.component.styled';
// Translations
import { BACKGROUND_DESCRIPTION } from './translations/background-content.translations';

const BackgroundContentComponent = (): React.ReactNode => (
  <BackgroundContentComponentStyled>
    <Illustration {...BACKGROUND_ILLUSTRATION_COMPONENT_PROPS} />
    <ParagraphComponent>
      <FormattedMessage id={BACKGROUND_DESCRIPTION} />
    </ParagraphComponent>
  </BackgroundContentComponentStyled>
);

export { BackgroundContentComponent };
